var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportPrintIcon = function SvgExportPrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "280.333 199.517 24.167 22.959"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M301.479 203.746h-18.125v1.813h18.125z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M280.333 212.205H304.5v-4.23a2.423 2.423 0 0 0-2.417-2.416H282.75a2.424 2.424 0 0 0-2.417 2.416z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M282.75 218.851h19.333a2.424 2.424 0 0 0 2.417-2.417v-4.833h-24.167v4.833a2.425 2.425 0 0 0 2.417 2.417"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00E676",
    d: "M302.083 208.58a.605.605 0 1 0 0-1.21.605.605 0 0 0 0 1.21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M300.271 199.517h-15.708v6.042h15.708z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M300.573 215.83h-16.312a.93.93 0 0 1-.907-.906.93.93 0 0 1 .907-.907h16.312a.93.93 0 0 1 .906.907.93.93 0 0 1-.906.906"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M300.271 215.83h-15.708v6.646h15.708z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M300.271 214.621h-15.708v1.209h15.708z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M297.854 217.038h-10.271v1.208h10.271zM295.438 219.455h-7.855v1.208h7.855z"
  })));
};
export default SvgExportPrintIcon;